/* eslint-disable default-param-last */
import {
  GET_HOME_SUCCESS,
  GET_BRANDS_SUCCESS,
  GET_PLANS_SUCCESS
} from 'constants/constants';

export default (
  state = {
    images: [],
    brands: [],
    ads: [],
    plans: []
  },
  action
) => {
  switch (action.type) {
    case GET_HOME_SUCCESS:
      return {
        ...state,
        ads: [...state.ads, ...action.payload.ads],
        images: [...state.images, ...action.payload.images]
      };
    case GET_BRANDS_SUCCESS:
      return {
        ...state,
        brands: [...state.brands, ...action.payload.brands]
      };
    case GET_PLANS_SUCCESS:
      return {
        ...state,
        plans: [...state.plans, ...action.payload.plans]
      };
    default:
      return state;
  }
};
